import { Injectable } from '@angular/core';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadPromise: Promise<google.maps.MapsLibrary> | null = null;

  load(): Promise<google.maps.MapsLibrary> {
    if (this.loadPromise !== null) {
      return this.loadPromise;
    }

    setOptions({
      key: environment.mapKey,
      v: 'weekly',
    });

    const promise = importLibrary('maps');
    this.loadPromise = promise;
    return promise;
  }
}
